/**
 * Estimativas / flags de virtualização Em aberto (cidades + rows).
 *
 * As constantes espelham o CSS real (App.css): estimativa errada desloca o
 * item enquanto ele não foi medido e abre espaço em branco entre cidades.
 */

export const OPEN_COLUMN_CITY_VIRTUAL_ENABLED = true;
export const OPEN_COLUMN_CITY_VIRTUAL_MIN = 8;

/** Espaço curto e fixo entre agrupamentos de cidade (gap do virtualizer / flex). */
export const OPEN_COLUMN_CITY_GAP_PX = 8;

/** Rows dentro de .city-orders-container (max-height 168px). */
export const OPEN_COLUMN_CITY_ORDERS_VIRTUAL_ENABLED = true;
export const OPEN_COLUMN_CITY_ORDERS_VIRTUAL_MIN = 8;
/** .order-row: min-height 22px (border-box, células 9px). */
export const OPEN_COLUMN_CITY_ORDERS_ROW_PX = 22;
export const OPEN_COLUMN_CITY_ORDERS_VIEWPORT_PX = 168;

/** .city-header: padding 6px + conteúdo ~14px (título 10px / contador 9px). */
const CITY_HEADER_PX = 26;
/** .kanban-fixed-column .city-group: border-top none, border-bottom 1px. */
const CITY_BORDER_PX = 1;

/**
 * Altura do card de cidade: header + bloco de ordens (limitado pelo container).
 * Sem o gap entre cidades — esse espaçamento fica no virtualizer/flex.
 */
export function estimateOpenColumnCityGroupSize(group) {
  const n = Array.isArray(group?.ordens) ? group.ordens.length : 0;
  const ordersBlock = Math.min(
    Math.max(1, n) * OPEN_COLUMN_CITY_ORDERS_ROW_PX,
    OPEN_COLUMN_CITY_ORDERS_VIEWPORT_PX
  );
  return CITY_HEADER_PX + ordersBlock + CITY_BORDER_PX;
}

export function estimateOpenColumnOrderRowSize() {
  return OPEN_COLUMN_CITY_ORDERS_ROW_PX;
}

export function shouldVirtualizeOpenColumnCityOrders(orderCount) {
  return (
    OPEN_COLUMN_CITY_ORDERS_VIRTUAL_ENABLED &&
    Number(orderCount) >= OPEN_COLUMN_CITY_ORDERS_VIRTUAL_MIN
  );
}
